// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular.json`.

export const environment = {
  production: false,

  //baseURL : 'https://test-api.cycloan.io/api/v1/',
 // baseURL : 'https://test-api.cycloan.io/api/v1/',
 baseURL : 'https://api.cycloan.io/api/v1/',
  //baseURL : 'http://localhost:3001/api/v1/',

     firebase : {
      apiKey: "AIzaSyCJXyngbHrRYXyizpcv0PJEFedyVgwzrd0",
     authDomain: "cycloan-a594c.firebaseapp.com",
    //   authDomain: "http://devapp.cycloan.io",
      //authDomain: "http://devapp.cycloan.io",
   //   authDomain: "devapp.cycloan.io",
      projectId: "cycloan-a594c",
      storageBucket: "cycloan-a594c.appspot.com",
      messagingSenderId: "1086814916037",
      appId: "1:1086814916037:web:59687ae76e21005ec6cfac",
      measurementId: "G-FC5RW7E8X1"
    }
  // firebase: {
  //   apiKey: "AIzaSyCT3RBizR3QovznpFh64dCX4KGSITSBUVI",
  //   authDomain: "cycloan-5bc87.firebaseapp.com",
  //   databaseURL: "https://cycloan-5bc87.firebaseio.com",
  //   projectId: "cycloan-5bc87",
  //   storageBucket: "cycloan-5bc87.appspot.com",
  //   messagingSenderId: "619280207375",
  //   appId: "1:619280207375:web:8f204f93305ebced129d7a",
  //   measurementId: "G-46KLC1SLJ6"

  //   // apiKey: "AIzaSyDsvMATDet7UkbUkUgjhHHa8e-jRaaXwRw",
  //   // authDomain: "http://uat.cycloan.io",
  //   // databaseURL: "https://mobiledemo-e0206.firebaseio.com",
  //   // projectId: "mobiledemo-e0206",
  //   // storageBucket: "mobiledemo-e0206.appspot.com",
  //   // messagingSenderId: "500252034390",
  //   // appId: "1:500252034390:web:c47e36507beb2d8115c2f7",
  //   // measurementId: "G-5DSH27P70B"
  // }
};
